import { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import FilterSelect from "../Filter/FilterSelect";
import NormalizedStackedBarChart from "../d3Charts/NormalizedStackedBarChart/NormalizedStackedBarChart";
import Loader from "../Loader/Loader";
import { faAlignCenter } from "@fortawesome/free-solid-svg-icons";
import AxiosService from "../../utils/AxiosService";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { KEY_NAME } from "../../utils/KeyName";
import "./ReuseLicense.scss";
import { colorArray } from "../../utils/theme";
import AboutChartToggle from "../AboutChartToggle/AboutChartToggle";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import SomethingWentWrong from "../SomethingWentWrong/SomethingWentWrong";

const publicationOptions = [
  { label: "All Publications", value: "ALL" },
  {
    label: "Verified open access on publisher's site",
    value: "open_access",
  },
];

const ReuseLicenseInner = ({ queryDataObj }) => {
  const { get, set, setMultiple } = useCustomSearchParams();
  const { entityName, selectedFilterBy, selectedFilterByLabel } =
    useContext(AppContext);
  const [publicationFilter, setPublicationFilter] = useState(
    publicationOptions[0],
  );
  const [normalizedStackedBarData, setNormalizedStackedBarData] =
    useState(null);
  const [queryData, setQueryData] = useState(null);

  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const axiosService = new AxiosService();

  useEffect(() => {
    if (publicationFilter) {
      setQueryData((prev) => ({ ...prev, reuseType: publicationFilter.value }));
    }
  }, [publicationFilter]);

  useEffect(() => {
    // if (hasFetched.current) return;
    // hasFetched.current = true;
    if (!entityName) return;
    if (!queryData) return;
    // const publisherQuery = buildPublisherQuery(publisher);

    setLoading(true);
    setHasError(false);

    if (queryData) {
      switch (entityName) {
        case KEY_NAME.FUNDER:
          // axiosService
          //   .getFunderOkCounts(queryData, shortName)
          //   // .getFunderOkCounts(publisherQuery, shortName)
          //   .then((response) => {
          //     setVerticalBarChartData(response.data);
          //   })
          //   .catch((error) => {
          //     console.error("Publisher Report Error:", error);
          //   })
          //   .finally(() => {
          //     // setLoading(false); // STOP LOADER
          //   });

          axiosService
            .getFunderReuseLicense({ ...queryDataObj, ...queryData }, shortName)
            .then((response) => {
              setNormalizedStackedBarData(response.data);
            })
            .catch((error) => {
              console.error("Error:", error);
              setNormalizedStackedBarData(null);
              setHasError(true);
            })
            .finally(() => {
              setLoading(false);
            });

          break;
        case KEY_NAME.PUBLISHER:
        case KEY_NAME.INSTITUTION:
          axiosService
            .getPublisherReuseLicense(
              { ...queryDataObj, ...queryData },
              shortName,
            )
            .then((response) => {
              setNormalizedStackedBarData(response.data);
            })
            .catch((error) => {
              console.error("Error:", error);
              setNormalizedStackedBarData(null);
              setHasError(true);
            })
            .finally(() => {
              setLoading(false);
            });

          break;
        // case KEY_NAME.INSTITUTION:
        //   axiosService
        //     .getPublisherReuseLicense(queryData, shortName)
        //     .then((response) => {
        //       setNormalizedStackedBarData(response.data);
        //     })
        //     .catch((error) => {
        //       console.error("Error:", error);
        //     })
        //     .finally(() => {
        //       setLoading(false);
        //     });
        //   break;

        default:
          break;
      }
    }
  }, [entityName, queryData, queryDataObj]);

  return (
    <div className="reuse-license position-relative ">
      <div className="mb-3">
        {/* <p className="text-secondary text-start">
          Graph represents the percentage of reuse license terms available in
          publication metadata. Hover over colored bars to see values.
        </p> */}
        <AboutChartToggle
          notes="Graph represents the percentage of reuse license terms available in
          publication metadata. Hover over colored bars to see values."
        />
      </div>
      {/* Filter & Download */}
      <div className="reuse-license__header" style={{ zIndex: 100 }}>
        <FilterSelect
          label=""
          icon={faAlignCenter}
          width="full"
          value={publicationFilter.label}
          options={publicationOptions}
          onChange={setPublicationFilter}
        />
      </div>
      {loading ? (
        <Loader />
      ) : hasError ? (
        <SomethingWentWrong />
      ) : (
        <div className="reuse-license-chart">
          <NormalizedStackedBarChart
            // data={normalizedStackedBarData}
            chartData={normalizedStackedBarData?.data}
            chartConfig={normalizedStackedBarData?.config}
            chartType="percentage"
            // data={data}
            title={`${shortName}${selectedFilterBy !== "ALL" ? "__" + selectedFilterByLabel?.trim() : ""}  Reuse Liense Type Tracked by CHORUS`}
            notes=""
            legentPosition="top"
            colorArray={colorArray}
          />
        </div>
      )}
    </div>
  );
};

const ReuseLicense = (props) => (
  <ErrorBoundary>
    <ReuseLicenseInner {...props} />
  </ErrorBoundary>
);

export default ReuseLicense;
